import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from 'ra-language-english';
import fr from 'ra-language-french';

import frTranslations from './fr';

const translations = { en, fr: { ...fr, ...frTranslations } };

export const i18nProvider = polyglotI18nProvider(
    locale => translations[locale],
    'en',
    [
        { locale: 'en', name: 'English' },
        { locale: 'fr', name: 'Français' }
    ],
    { allowMissing: true }
);

export default i18nProvider;